module Meevo.Components.Common {

    export interface IWysiwygApi {
        scope: angular.IScope;
        insertImage?(): angular.IPromise<any>;
        insertLink?(): angular.IPromise<any>;
    }

    export interface IWysiwygConfig {
        sanitize?: boolean;
        fontAwesome?: boolean;
        toolbar?: object[];
    }

    export interface ICommonDataService extends Meevo.Components.BaseClasses.IDataService {
        getSmartCenter(id: Guid): angular.IPromise<any>;
        getUserSmartCenters(): angular.IPromise<any>;
        getSmartCenterExtendedData(id: Guid): angular.IPromise<any>;
        getReportList(): angular.IPromise<any>;
        isSessionValid(): angular.IPromise<boolean>;
        refreshIdentity(locationId: number): angular.IPromise<any>;
        getIdentity(): angular.IPromise<any>;
        getIdentityFull(): angular.IPromise<any>;
        login(account: any, config?: Object): angular.IPromise<any>;
        logout(): angular.IPromise<any>;
        getPostalCodeInfo(request: any): angular.IPromise<any>;
        customMethodData(uri: string, method: string, data: any): angular.IPromise<any>;
        customMethodData(uri: string, method: string, data: any, params?: any): angular.IPromise<any>;
        getSmartTileDefinitions(categoryId: number): angular.IPromise<any>;
        getSmartTileData(smartTileId: Guid, smartCenterId: Guid): angular.IPromise<any>
        getThemeCss(tenantId: number): angular.IPromise<any>;
    }

    export interface ISystemSettings {
        isTrainingEnvironment: boolean;
        isTestingEnvironment: boolean;
        isSandboxEnvironment: boolean;
        reportsUrl: string;
        screenConnectBase?: string;
        meevoCoHelpUrl: string;
        meevoLocationHelpUrl: string;
        meevoSingleLocationHelpUrl: string;
        advancedMarketingPortalUrl: string;
        canRunReportsInSandboxSingleLocation: boolean;
        canRunReportsInSandboxMultiLocation: boolean;
        storageUrl: string;
        isTollFreeNumberSupported: boolean;
    }

    export interface IIdentity {
        authProviderName: string;
        EmployeeAppointmentBookViewPreference: Object;
        daysRemainingForPasswordChange: number;
        displayName: string;
        elevatedSessions: Object;
        firstName: string;
        homeLocationId: number;
        centralOfficeId?: number;
        callCenterId?: number;
        id: string;
        employeeId?: string;
        isAuthenticated: boolean;
        isLockedOut: boolean;
        isSingleLocation: boolean;
        languageId: number;
        lastModified: Date;
        lastName: string;
        locationId: number;
        locationName: string;
        locationTimeZone: Object;
        locationUrl: string;
        loginAttempts: number;
        logoutUrl: string;
        lastUsedDrawerId: string;
        needsToChangePasword: boolean;
        providerOAuthAccess: any;
        sessionBag: Object;
        sessionTimeoutRedirectUrl: string;
        sessionTimeoutMinutes: string;
        storeNumber: string;
        tag: number;
        tenantId: number;
        tenantUrl: string;
        userAuthId: Guid;
        userAuthName: string;
        userLocalAddress: string;
        userHostAddress: string;
        userId: Guid;
        userName: string;
        systemSettings: ISystemSettings;
        sessionId?: string;
        isSandbox?: boolean;
        tenantData: ITenantData;
        timeZone: string;
        requireChangePassword: boolean;
        businessTypeId: string;
        fullAccess: boolean;
        requiresPunchIn: boolean;
        tenantName: string;
        userBusinessTypeIds: any[];
        decimalPositions: number;
        tenantBusinessTypeCount?: number;
        LearningTrack?: string;
        salesForceId?: string;
        asImpersonateLocationId?: number;
        effectiveCallCenterId?: number;
        restrictedAccess?: boolean;
        emailAddress?: string;
        userTypeEnum?: Model.UserTypeEnum;
        bearerToken?: string;
    }

    export interface IEmulateResponse {
        security: Array<Model.SecurityItem>;
        identity: IIdentity;
        businessHours: Meevo.Model.BusinessHours[];
        appointmentBookSettings: Meevo.Model.AppointmentBookSettings;
        timeZoneOffset: number;
    }

    export interface IIdentityService {
        isAuthProviderJcp: boolean;
        inCallCenterMode(): boolean;
        inCentralOfficeMode(): boolean;
        inSandboxMode(): boolean;
        businessTypeId: string;
        locationId: number;
        tenantName: string;
        current(): IIdentity;
        setIdentity(identity: IIdentity): void;
        isSingleLocation(): boolean;
        inTestOrTrainingMode(): boolean;
        isUserHasBusinessTypeIds(): boolean;
        userBusinessTypes: Model.DataDetail[];
        loggedInUserId(): Guid;
        checkCentralOfficeLocationId(locId: number): boolean;
        tenantBusinessTypeCount?: number;
        isAutoLogoutActive?: boolean;
        isEmulating: boolean;
        emulationData: IEmulationData;
        effectiveLocationId: number;
        isJcpTenant: boolean;
        isMeTenant: boolean;
        clearToken(): void;
        setToken(jwt: string): void;
    }

    export interface ITenantData {
        allBusinessTypeId: string;
    }

    export interface IDataExportService {
        generateFile(data: any, filename: string, type: FileTypeEnum): void;
        generateTXT(data: any, filename: string, type: FileTypeEnum): void;
    }

    export interface IEmulationData {
        effectiveCallCenterId: number,
        asImpersonateLocationId: number,
        loggedInLocation: number,
        userId?: Guid
    }


    /**
    * Defines contract for all api endpoints available within the application.
    */
    export interface IAPIEndPoints {
        docsAndForms: string;
        docsAndFormsKiosk: string;
        accountsync: string;
        accountsyncDesktop: string;
        addOnGroup: string;
        alertsManager: string,
        alertsLog: string,
        alertLogDetail: string,
        alertCategory: string;
        alertSetting: string;
        appointmentSchedule: string;
        blockSchedule: string;
        blockType: string;
        businessInfo: string;
        businessTypes: string;
        locationGroups: string;
        location: string;
        cancellationReason: string;
        client: string;
        clientClientType: string;
        clientMerge: string;
        clientManualMerge: string;
        discount: string;
        drawer: string;
        drawerHistory: string;
        drawerManager: string;
        drawerSession: string;
        egifts: string;
        shippingFees: string;
        employee: string;
        teachers: string;
        employeeCategory: string;
        employeeTemplate: string;
        employeeTemplatePromotion: string;
        fieldLabels: string;
        inventoryCount: string;
        inventoryReturn: string;
        inventoryTransfer: string;
        notificationSetting: string;
        tax: string;
        productcategories: string,
        stockLevels: string,
        giftCardType: string;
        referralType: string;
        securityRole: string;
        service: string;
        reportServices: string;
        reportScheduler: string;
        serviceCategory: string;
        session: string;
        visitNoteType: string;
        resource: string;
        appointmentCategory: string;
        notificationTemplate: string;
        onlineBookingSettings: string;
        resourceCategory: string;
        distributor: string;
        manufacturer: string;
        posHardware: string;
        product: string;
        productBulkUpdate: string;
        productInfoModal: string;
        productBundles: string;
        payinoutreasons: string;
        purchaseOrder: string;
        workActivity: string;
        appointmentRequest: string;
        equipment: string;
        walkinAppointment: string;
        walkInSettings: string;
        paymentType: string;
        financialInfoSetting: string;
        sale: string;
        saleHold: string;
        packageType: string;
        meevoBi: string;
        memberships: string;
        membershipTypes: string;
        memberBenefitTemplates: string;
        membershipCancellation: string;
        membershipManager: string,
        meevoTheming: string,
        floorLocation: string;
        customData: string;
        swapGroup: string;
        reportingHierarchy: string;
        report: string;
        reportCategories: string;
        alertConfigReport: string;
        ipRestriction: string;
        marketPricing: string;
        transactionEditor: string;
        profileSettings: string;
        holiday: string;
        merchantAccount: string;
        integration: string;
        eventSchedule: string;
        customBranding: string;
        clientPoint: string;
        compensationSettings: string;
        clockInOutRulesSettings: string;
        periodSettings: string;
        cultureSettings: string;
        employeeSupplyUsage: string;
        clientPackageHistory: string;
        clientPackageHistoryById: string;
        smartCenter: string;
        clientCreditCard: string;
        giftCardIntegration: string;
        splitCommissionSettings: string;
        //todo add IAPIEndPoints activity log
        imageGalleryCategory: string;
        saleProgram: string;
        eftControlPanel: string;
        payroll: string;
        basicEmailMarketing: string;
        departments: string;
        department: string;
        departmentGoal: string;
        employeeGoal: string;
        dashboardGoals: string;
        meevoStore: string;
        pointPromotionCampaign: string;
        promotionCampaign: string;
        miscSupplyDefinitions: string;
        transworld: string;
        techSphere: string;
        textel: string;
        meevoMessenger: string;
        meevoMessengerSettings: string;
        textelBlast: string;
        paging: string;
        salesRankings: string;
        ratingsControlPanel: string;
        servicesWizard: string;
        students: string;
        ratingClientSummary: string;
        ratings: string;
        clientIntakeForm: string;
        clientIntakeFormBuilder: string;
        selfCheckInKioskSettings: string;
        selfCheckInKiosk: string;
        aveda: string;
        employeeServiceTimesPricing: string;
        fiveStarRatingSettings: string;
        serviceCharges: string;
        fameAdvantage: string;
        adpRunIntegration: string;
        adpWfnIntegration: string;
        adpWiselyIntegration: string;
        royaltyExport: string;
        onlinePresenceManagement: string;
        onlinePresenceSettings: string;
        systemToolbox: string;
        yieldManagementStrategy: string;
        yieldManagementProgram: string;
        systemVersions: string;
        clientApp: string;
        usageReasons: string;
        paymentPlans: string;
        tippy: string;
        pbiDashboards: string;
        knowledgeArticles: string;
    }

    /**
    * Defines contract for all ui routes available within the application.
    */
    export interface IRouteNames {
        accountsync: string;
        quickbooksDesktop: string;
        addOnGroup: string;
        appointmentBook: string;
        standingBlocks: string;
        blockTypes: string;
        businessInfo: string;
        businessTypes: string;
        businessPreferences: string;
        consumerAppSettings: string;
        locationGroups: string;
        location: string;
        notificationSetting: string;
        tax: string;
        cancellationReasons: string;
        client: string;
        clientClientType: string;
        clientMerge: string;
        clientManualMerge: string;
        confirmationManager: string;
        controlGallery: string;
        fieldLabels: string;
        distributors: string;
        drawer: string;
        drawerHistory: string;
        drawerManager: string;
        manufacturer: string;
        discounts: string;
        egifts: string;
        shippingFees: string;
        emmaAccountSettings: string;
        employee: string;
        teachers: string;
        employeeCategories: string;
        employeeTemplates: string;
        employeeTemplatePromotions: string;
        giftCardTypes: string;
        home: string;
        itemDetail: string;
        localizationTest: string;
        login: string;
        meevoTheming: string;
        meevoBi: string;
        manufacturers: string;
        onlineBooking: string;
        productCategories: string;
        referralTypes: string;
        register: string;
        reports: string;
        reportScheduler: string;
        reportingHierarchy: string;
        search: string;
        securityRoles: string;
        securityRolesManager: string;
        services: string;
        serviceCategories: string;
        standingAppointments: string;
        styleGallery: string;
        meevoPay: string;
        visitNoteTypes: string;
        resources: string;
        appointmentCategories: string;
        callCenter: string;
        notificationTemplates: string;
        waitList: string;
        resourceCategory: string; //Singular because action buttons in type ahead in resources module.
        distributor: string;
        workActivities: string;
        product: string;
        productBulkUpdate: string;
        productBundles: string;
        payinoutreasons: string;
        purchaseOrder: string;
        equipment: string;
        stockLevels: string;
        walkinManagerSettings: string;
        walkinManager: string;
        walkinManagerKiosk: string;
        walkinManagerDisplay: string;
        onlineBookingSettings: string;
        financialInfoSetting: string;
        paymentType: string;
        userDefinedControls: string;
        posHardware: string;
        packageTypes: string;
        packages: string;
        paging: string;
        productInfoModal: string;
        memberships: string;
        membershipTypes: string;
        membershipDefinitions: string;
        memberBenefitTemplates: string;
        membershipCancellation: string;
        membershipManager: string;
        eftControlPanel: string;
        ipRestrictions: string;
        marketPricing: string;
        floorLocation: string;
        swapGroups: string;
        inventoryCount: string;
        inventoryTransfer: string;
        transactionEditor: string;
        profileSettings: string;
        holiday: string;
        merchantAccounts: string;
        integrations: string;
        eventSchedules: string;
        timeClock: string;
        customBranding: string;
        advancedCustomBranding: string;
        clientPoint: string;
        compensationSettings: string;
        clockInOutRulesSettings: string;
        periodSettings: string;
        cultureSettings: string;
        employeeSupplyUsage: string;
        miscSupplyDefinitions: string;
        smartCenters: string;
        giftCardBalance: string;
        giftCardIntegration: string;
        inventoryReturns: string;
        splitCommissionSettings: string;
        activityLog: string;
        alertsManager: string;
        alertsLog: string;
        charts: string;
        clientRecordManagement: string;
        imageGalleryCategory: string;
        packageLookup: string;
        saleProgram: string;
        sandbox: string;
        payroll: string;
        basicEmailMarketing: string;
        departments: string;
        department: string;
        departmentGoal: string;
        employeeGoal: string;
        dashboardGoals: string;
        meevoStore: string;
        pointPromotionCampaign: string;
        docsAndForms: string;
        docsAndFormsKiosk: string;
        transworld: string;
        techSphere: string;
        meevoMessenger: string;
        meevoMessengerSettings: string;
        textelBlast: string;
        salesRankings: string;
        ratingsControlPanel: string;
        servicesWizard:string;
        student: string;
        help: string;
        meevoInspo: string;
        remoteTraining: string;
        referAFriend: string;
        meevoFacebook: string;
        clientIntake: string;
        clientIntakeForm: string;
        selfCheckInKiosk: string;
        selfCheckInKioskSettings: string;
        aveda: string;
        employeeServiceTimesPricing: string;
        fiveStarRatingSetting: string;
        serviceCharges: string;
        fameAdvantage: string;
        adpRunIntegration: string;
        adpWfnIntegration: string;
        adpWiselyIntegration: string;
        royaltyExport: string;
        onlinePresenceManagement: string;
        onlinePresenceSettings: string;
        systemToolbox: string;
        yieldManagementStrategy: string;
        yieldManagementProgram: string;
        interopSample: string;
        newSchedules: string;
        newFormBuilder: string;
        newIntakeFormBuilder: string;
        csvExport: string;
        systemVersions: string;
        clientApp: string; //ClientApp
        usageReasons: string;
        paymentPlans: string;
        paymentRequests: string;
        releaseNotes: string;
        tippy: string;
        pbiDashboards: string;
        advancedDashboardsHelp: string;
        myMeevoApp: string;
        timeOffRequests: string;
        zapier: string;
        knowledgeArticles: string;
        schedulesManager: string;
        onlineMembershipSettings: string;
        twoWaySmsOnboarding: string;
        salonInteractive: string;
        merchantOnboardingTesting: string;
        bulkLiabilityUpdate: string;
        bulkLiabilityTransfer: string;
    }

    /**
    * Defines special names for short description in audit
    */
    export interface IAuditNames {
        appointmentCategories: string;
        activityLog: string;
        alertsLog: string;
        charts: string;
        clientRecordManagement: string;
        alertsManager: string;
        blockTypes: string;
        businessPreferences: string;
        standingBlocks: string;
        basicEmailMarketing: string;
        businessTypes: string;
        payroll: string;
        cancellationReasons: string;
        client: string;
        clientClientType: string;
        clientPoint: string;
        confirmationManager: string;
        discounts: string;
        distributors: string;
        drawer: string;
        drawerHistory: string;
        drawerManager: string;
        eftControlPanel: string;
        egifts: string;
        shippingFees: string;
        employee: string;
        employeeCategories: string;
        employeeTemplates: string;
        employeeTemplatePromotions: string;
        employeeSupplyUsage: string;
        floorLocation: string;
        giftCardBalance: string;
        giftCardTypes: string;
        home: string;
        imageGalleryCategory: string;
        inventoryCount: string;
        inventoryReturns: string;
        inventoryTransfer: string;
        ipRestrictions: string;
        clientMerge: string;
        clientManualMerge: string;
        locationGroups: string;
        location: string;
        memberships: string;
        membershipCancellation: string;
        memberBenefitTemplates: string;
        membershipManager: string;
        membershipTypes: string;
        marketPricing: string;
        saleProgram: string;
        manufacturers: string;
        merchantAccounts: string;
        miscSupplyDefinitions: string;
        notificationTemplates: string;
        packageTypes: string;
        packageLookup: string;
        payinoutreasons: string;
        paymentType: string;
        product: string;
        productBulkUpdate: string;
        productBundles: string;
        productCategories: string;
        profileSettings: string;
        purchaseOrder: string;
        referralTypes: string;
        resources: string;
        resourceCategory: string;
        securityRoles: string;
        securityRolesManager: string;
        services: string;
        addOnGroup: string;
        smartCenters: string;
        standingAppointments: string;
        swapGroups: string;
        transactionEditor: string;
        visitNoteTypes: string;
        userDefinedControls: string;
        walkinManager: string;
        walkinManagerDisplay: string;
        walkinManagerKiosk: string;
        walkinManagerSettings: string;
        workActivities: string;
        departments: string;
        pointPromotionCampaign: string;
        dashboardGoals: string;
        docsAndForms: string;
        docsAndFormsKiosk: string;
        student: string;
        teachers: string;
        selfCheckInKiosk: string;
        serviceCharges: string;
        meevoBi: string;
        adpRunIntegration: string;
        adpWfnIntegration: string;
        adpWiselyIntegration: string;
        royaltyExport: string;
        quickbooksDesktop: string;
        accountsync: string;
        systemToolbox: string;
        yieldManagementStrategy: string;
        yieldManagementProgram: string;
        clientApp: string;
        usageReasons: string;
        paymentPlans: string;
        meevoPay: string;
        tippy: string;
        bulkLiabilityUpdate: string;
        bulkLiabilityTransfer: string;
    }

    /**
    * Defines contract all app settings
    */
    export interface IAppSettings {
        API_ENDPOINTS: IAPIEndPoints;
        APP_NAME: string;
        API_ROOT: string;
        APP_URL: string;
        APP_COUNTRIES: Object;
        APP_COUNTRYID: string;
        APP_LANGUAGEID: string;
        APP_CURRENCY: string;
        APP_TIME_FORMAT: number;
        APP_ISOCURRENCYCODE: string;
        APP_ISOCOUNTRYCODE: string;
        APP_FIELDLABELS: any;
        APP_AMPMS: string[];
        APP_BUSINFOSETTINGS: Meevo.Model.BusinessInfoSettings;
        LOGIN_URL: string;
        REPORT_SERVER_URL: string;
        ROUTE_NAMES: IRouteNames;
        AUDIT_NAMES: IAuditNames; // Todo: add interface
        SECURITY_ACCESS_KEYS: any;
        SERVER_EVENTS_API_URL: string;
        SERVER_EVENTS_ENABLED: boolean;
        MEEVO_MODULES_URL: string;
        INTEROP_URL: string;
    }

    export interface IPostalCodeService {
        lookupPostalCode(request: any): angular.IPromise<any>;
        getStates(request: any): angular.IPromise<any>;
    }

    export interface IPostalCode {
        city: string;
        province: string;
        state: string;
        postalCode: string;
    }

    export interface IHttpRequestObject {
        url: string;
        method: string;
        data?: any;
        params?: any;
    }

    export interface IPoleDisplayMessage {
        line1Text: string;
        line2Text: string;
    }

    export enum PoleDisplayAlignment {
        Left = 0, /* default */
        Right = 1,
        Spaced = 2, /* when there are two text items, first item will be left-aligned, second item will be right-aligned*/
        Scrolling = 3 /* marquee effect */
    }

    export interface IPoleDisplayLine {
        text: string[];
        alignment?: PoleDisplayAlignment;
    }

    export interface IPoleDisplayObject {
        lines: IPoleDisplayLine[];
    }

    export interface IPrintProxyService {
        initialize(selectedPrinter: any);
        acknowledge();
        processQueue();
        postMessage(action: string, payload: any);
    }

    export interface IPrintService {
        /* Getter and Setter */
        getPrinterList(): angular.IPromise<IPrintServicePrinter[]>;
        getSelectedPrinter(): angular.IPromise<IPrintServicePrinter>;
        setSelectedPrinter(printer: IPrintServicePrinter): angular.IPromise<void>;
        setSelectedTerminal(terminal: Meevo.Model.MerchantTerminal): angular.IPromise<void>;

        /* Print methods */
        print(...documentUrls: string[]): angular.IPromise<any>;
        printToDevice(printerDetail: IPrintServicePrinter, ...documentUrls: string[]): angular.IPromise<any>;
        printCustom(...requestObjs: IHttpRequestObject[]): angular.IPromise<any>;
        printCustomToDevice(printerDetail: IPrintServicePrinter, ...requestObjs: IHttpRequestObject[]): angular.IPromise<any>;

        /* POS Display methods */
        showStandbyMessage();
        queueMessagesToPoleDisplay(...messages: IPoleDisplayObject[]): void;
        queueMessagesToPoleDisplayToDevice(printerDetail: IPrintServicePrinter, ...messages: IPoleDisplayObject[]): void;
        resetPoleDisplay(printerDetail?: IPrintServicePrinter): angular.IPromise<any>;

        /* Drawer methods*/
        openDrawer(printerDetail?: IPrintServicePrinter): angular.IPromise<any>;
    }

    export interface IPrintServicePrinter {
        id: any;
        brandId: number;
        displayName?: string;
        deviceName?: string;
        ribbonSize?: number;
        ipAddress?: string;
        port?: number;
        isTrustEnabled?: boolean;
        isCustomerDisplayEnabled?: boolean;
        customerDisplayStandbyLine1?: string;
        customerDisplayStandbyLine2?: string;
    }

    export interface IReportRouterService {
        // reportKey - security key of the report, which includes the report shortcut in it
        // data - object or array that contains name-value pairs to be mapped to the report controls
        routeToReport(reportKey: string, data: any): void;
    }

    export interface IReportMapper {
        // valueName - name associated with the value being requested
        getDataValue(valueName: string): any;
    }

}
